import { ProfileNutrition } from './profile-nutrition';

export class PlanningMenu {
    Id: number;
    Name: string;
    IsHidden: boolean;
    ProfilesMenu: ProfileNutrition[] = [];
}


// WEBPACK FOOTER //
// ./src/app/shared/models/planning-menu.ts